import { render, staticRenderFns } from "./CultureCard.vue?vue&type=template&id=024cfdef"
import script from "./CultureCard.vue?vue&type=script&lang=js"
export * from "./CultureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports